module.exports = __webpack_public_path__ + "img/ceea105.jpg";